(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const pageParam = parseInt(url.searchParams.get('page'), 10);

  if (url.hash) {
    /* Deep-link to a specific product card via hash */
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  } else if (pageParam > 1) {
    /* Landing on page 2+ (bookmark, back-button): scroll to the product grid */
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const grid = document.getElementById('ResultsList');
        if (grid) {
          grid.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
